import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, Typography } from "@mui/material";
import requests from "api/requests";
import React, { useEffect, useState } from "react";
import { Deserializer } from "ts-serializer-core";
import { CardProps } from "../types";
import DriverRequestSettings from "./driverRequestSettings";
import { StyledDialogTitle } from "./styles";
import { AtpSerializer } from "./types";

export default function AtpCard(props: CardProps) {
  const {
    id,
    onClose,
    onChanged,
  } = props
  const [data, setData] = useState<AtpSerializer | null>(null);

  useEffect(() => {
    const abortController = new AbortController();

    if (!id) {
      abortController.abort();
    } else {
      setData(null);
      requests.get(`/atp/atp/${id}/`, {}, abortController.signal).then((r) => {
        const deserializer = new Deserializer();
        const instance = deserializer.deserialize(AtpSerializer, r.body);
        setData(instance);
      })
    }

    return () => {
      abortController.abort();
    };
  }, [id])


  return (
    <Dialog
      open={!!id}
      onClose={onClose}
      maxWidth="md"
      fullWidth={!!data}
    >
      {!data ? (
        <DialogContent>
          <CircularProgress sx={{ display: "block" }} />
        </DialogContent>
      ) : (
        <React.Fragment>
          <StyledDialogTitle>{data.name}</StyledDialogTitle>
          <DialogContent dividers>

            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={1} direction="column">
                  <Grid item>
                    <Typography color="textSecondary" component="span">Прізвище: </Typography>
                    {data.owner?.last_name}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">Ім'я: </Typography>
                    {data.owner?.first_name}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">По батькові: </Typography>
                    {data.owner?.middle_name}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">Час перезмінки: </Typography>
                    {data.replacement_time}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={1} direction="column">
                  <Grid item>
                    <Typography color="textSecondary" component="span">Телефон офісу: </Typography>
                    {data.owner?.office_phone}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">Телефон: </Typography>
                    {data.owner?.phone}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">Додатковий телефон: </Typography>
                    {data.owner?.second_phone}
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" component="span">E-mail: </Typography>
                    {data.owner?.email}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Box sx={{ mt: 2, mb: 1 }}>
              <Accordion TransitionProps={{ unmountOnExit: true }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>Набор водіїв</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <DriverRequestSettings
                    atpID={data.id!}
                    settings={data.driver_request_settings!}
                    onChanged={() => {
                      onChanged?.()
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Закрити</Button>
          </DialogActions>
        </React.Fragment>
      )}
    </Dialog>
  )
}